import { useEffect, useRef, useState } from 'react';
import styles from './input.scss';
import { InputProps } from 'components/Shared/Form/themes/BGH/input';

const PADDING = 10;

type UnitProps = Pick<InputProps, 'value' | 'unit'>;

export const Unit = ({ value, unit }: UnitProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (ref.current) {
      setWidth(ref.current.getBoundingClientRect().width);
    }
  }, [ref, value]);

  return (
    <>
      <span className={styles.hide} ref={ref}>
        {value}
      </span>
      <span className={styles.unit} style={{ left: `${width + PADDING}px` }}>
        {unit}
      </span>
    </>
  );
};
